import { get, post } from './http-calls';

export const getMenuItems = async () => {
    let res = await get(`NavigationMenus/RoleBasedMenu`, { useAuthToken: true });
    return res;
};
